<template>
<div v-cloak>
  <Top />
  <div class="maindiv mcollege-wrap bg-gray">
    <div class="list-bg mlist-bg"></div>
    <div class="college bgw htmldiv mt135 pl30">
      <div class="lh10 pt40">
        <img class="vcenter" src="../../../assets/images/tt_01.jpg" alt="">
        <span class="vcenter fs24 fbold tc17">学院简介</span>
      </div>
      <div class="cont">
        <div class="tdiv">
          <div class="ldiv dinline-block vtop fs16" v-html="school.detail">
          </div>
          <div class="rdiv dinline-block vtop tc6 pt15">
            <SchoolTag v-for="(item,index) in schoolTag" :key="index" :index="index" :item="item"/>
          </div>
        </div>
<!--        <div class="bdiv fs16">-->
<!--          <Teacher v-for="(item,index) in teachers" v-if="index < 9" :key="index" :index="index" :item="item"/>-->
<!--        </div>-->
      </div>
    </div>
    <div class="ht20"></div>

  </div>

  <Bottom />

</div>
</template>

<script>
// import Top from '../top.vue'
import Top from '../../index/top.vue'
import Bottom from '../../index/bottom.vue'
import SchoolTag from './school-tag.vue'
import Teacher from './teacher.vue'
export default {
  name: "index",
  data () {
    return {
      'school': {},
      'schoolTag': [],
      'teachers': [],
    }
  },
  components:{
    Top,
    Bottom,
    SchoolTag,
    Teacher,
  },
  created() {
    var getParam = {};
    this.$request.get('school/tai-detail',getParam,response => {
      if(response.status == 200){
        this.school = response.data.data.school;
        this.schoolTag = response.data.data.schoolTag;
        this.teachers = response.data.data.schoolTeacher;
      }
    },error => {
      console.log(error);
    })
  }
}
</script>

<style scoped>
  .list-bg{height: 305px;}
  .mlist-bg{background: #bfccee url(../../../assets/images/list_01_01.jpg) no-repeat center top;}
  .mcollege-wrap .college .cont{padding: 65px 0 80px 35px;}
  .mcollege-wrap .college .ldiv{width: 530px;line-height: 2.7;}
  .mcollege-wrap .college .rdiv{margin-left: 80px;width: 600px;}
  .mcollege-wrap .college .bdiv{margin-top: 200px;}
</style>



// WEBPACK FOOTER //
// src/components/main/about/index.vue